import useAuthStore, { useAuthHydrated } from '@/stores/authStore';

/**
 * Backwards-compatible hook that wraps the Zustand auth store.
 * All existing components using useAuth() will continue to work.
 */
export const useAuth = () => {
  const store = useAuthStore();
  const isHydrated = useAuthHydrated();

  return {
    user: store.user,
    patchUser: store.patchUser,
    accessToken: store.accessToken,
    setAccessToken: store.setAccessToken,
    businesses: store.businesses,
    selectedBusiness: store.selectedBusiness,
    setSelectedBusiness: store.setSelectedBusiness,
    logout: store.logout,
    can: store.can,
    isAuthLoading: store.isAuthLoading,
    isHydrated: isHydrated,
    refreshUserData: store.refreshUserData,
    next: store.next,
    setNext: store.setNext,
    timezone: store.timezone,
  };
};

/**
 * @deprecated AuthProvider is no longer needed with Zustand.
 * The store initializes automatically. Use AuthInitializer component instead.
 */
export const AuthProvider = ({ children }) => {
  // Pass-through - Zustand handles persistence
  return children;
};

// Re-export isJwtExpired for backwards compatibility (no longer used with cookie-based auth)
export { isJwtExpired } from '@/stores/authStore';

export default useAuth;
